module.exports = __webpack_public_path__ + "static/scale-model-of-lena-love-photography-in-cleveland-ohio-00f8e0526dea8851f3e5afbeeb81a854.png";